import NoDataFound from "../components/CommonComponents/NoDataFound";

const renderNoDataHelper = (products) => {
    if (!products?.length) {
      return <NoDataFound />;
    }
    return null;
  };

export default renderNoDataHelper;